import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

export default function (ComposedComponent) {
  class Authentication extends Component {
    componentDidMount() {
      if (!this.props.authenticated) {
        let currentURL = window.location.href.toString()
        localStorage.setItem('originalURL', currentURL );
        this.props.history.push('/login');
      }
    }

    componentDidUpdate(nextProps) {
      if (!nextProps.authenticated) {
        let currentURL = window.location.href.toString()
        localStorage.setItem('originalURL', currentURL );
        this.props.history.push('/login');
      }
    }

    PropTypes = {
      router: PropTypes.object,
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return { authenticated: state.userData.authenticated };
  }

  return connect(mapStateToProps)(Authentication);
}
